import { ZonedMoment } from "@util/time-zone";

export function getNextDefragText(
  nextDefragTime: number,
  showTimeIfNotToday = true,
  now = new ZonedMoment(),
): string {
  const defragLocalRunTime = new ZonedMoment(nextDefragTime);

  let defragLocalRunText = `at ${defragLocalRunTime.format("h:mma")}`;
  let dayText = "";

  if (defragLocalRunTime.isSame(now.clone().add(1, "days"), "days")) {
    dayText = "tomorrow";
  } else if (defragLocalRunTime.isAfter(now.clone().add(1, "days"), "days")) {
    dayText = `${defragLocalRunTime.format("dddd")}`;
  }

  if (dayText.length && showTimeIfNotToday) {
    defragLocalRunText += ` ${dayText}`;
  } else if (dayText.length) {
    defragLocalRunText = dayText;
  }

  return defragLocalRunText;
}
